// extracted by css-extract-rspack-plugin
export default {"center":"center-NDm9oY","stack":"stack-_yUTnw","title":"title-gIYnEM","body":"body-g3WJwD"};